export const POS_BACKEND_PORT: string = '3040';
